(function () {
  /* HELPERS */
  const waitUntil = ms =>
    new Promise(resolve => setTimeout(() => resolve(true), ms));
  /* END - HELPERS */

  /* SELECTORS */
  const isaqbSection = '#isaqb';
  const safeSection = '#safe';
  const irebSection = '#ireb';
  const istqbSection = '#istqb';
  const ecCouncilSection = '#ec-council';
  const comptiaSection = '#comptia';
  const awsSection = '#aws';
  const microsoftAzureSection = '#microsoft-azure';
  const tectrainSection = '#tectrain';
  const uxqbSection = '#uxqb';
  const itilSection = '#itil';
  const management3Section = '#management-3-0';
  const scrumSection = '#scrum';
  const scrumIncSection = '#scrum-inc';

  const sectionItem = '.amv2-section-item--course';
  /* END - SELECTORS */

  /* DOM ELEMENTS */
  const amv2 = document.querySelector('.amv2');
  const amv2ContentContainer = amv2.querySelector('.amv2__content-container');
  /* END - DOM ELEMENTS */

  /* HANDLERS */
  const scrollBarSetter = () => {
    const activeSection = amv2.querySelector('.amv2-content.active');
    const scrollBar = activeSection.querySelector('.amv2-content__scrollbar');

    if (activeSection.scrollHeight > activeSection.offsetHeight) {
      if (!scrollBar.classList.contains('active')) {
        scrollBar.classList.add('active');
      }

      const activeSectionScrollHeight = activeSection.scrollHeight;
      const activeSectionHeight = activeSection.offsetHeight;
      const scrollBarHeight = scrollBar.offsetHeight;

      const scrollBarThumbHeight =
        (activeSectionHeight * scrollBarHeight) / activeSectionScrollHeight;

      const scrollBarThumb = scrollBar.querySelector('div');

      scrollBarThumb.style.height = `${scrollBarThumbHeight}px`;

      activeSection.onscroll = function () {
        const scrollBarScrollTop =
          (scrollBarHeight * activeSection.scrollTop) /
          activeSectionScrollHeight;

        scrollBarThumb.style.top = `${scrollBarScrollTop}px`;
      };
    } else {
      scrollBar.classList.remove('active');
    }
  };
  /* END - HANDLERS */

  const allModules = [
    {
      id: 'isaqb',
      modules: [...amv2.querySelectorAll(`${isaqbSection} ${sectionItem}`)],
    },
    {
      id: 'safe',
      modules: [...amv2.querySelectorAll(`${safeSection} ${sectionItem}`)],
    },
    {
      id: 'ireb',
      modules: [...amv2.querySelectorAll(`${irebSection} ${sectionItem}`)],
    },
    {
      id: 'istqb',
      modules: [...amv2.querySelectorAll(`${istqbSection} ${sectionItem}`)],
    },
    {
      id: 'ec-council',
      modules: [...amv2.querySelectorAll(`${ecCouncilSection} ${sectionItem}`)],
    },
    {
      id: 'comptia',
      modules: [...amv2.querySelectorAll(`${comptiaSection} ${sectionItem}`)],
    },
    {
      id: 'aws',
      modules: [...amv2.querySelectorAll(`${awsSection} ${sectionItem}`)],
    },
    {
      id: 'microsoft-azure',
      modules: [
        ...amv2.querySelectorAll(`${microsoftAzureSection} ${sectionItem}`),
      ],
    },
    {
      id: 'tectrain',
      modules: [...amv2.querySelectorAll(`${tectrainSection} ${sectionItem}`)],
    },
    {
      id: 'uxqb',
      modules: [...amv2.querySelectorAll(`${uxqbSection} ${sectionItem}`)],
    },
    {
      id: 'itil',
      modules: [...amv2.querySelectorAll(`${itilSection} ${sectionItem}`)],
    },
    {
      id: 'management-3-0',
      modules: [
        ...amv2.querySelectorAll(`${management3Section} ${sectionItem}`),
      ],
    },
    {
      id: 'scrum',
      modules: [...amv2.querySelectorAll(`${scrumSection} ${sectionItem}`)],
    },
    {
      id: 'scrum-inc',
      modules: [...amv2.querySelectorAll(`${scrumIncSection} ${sectionItem}`)],
    },
  ];

  const vTabButtons = [...amv2.querySelectorAll('.amv2-v-tabbar-button')];
  const vTabButtonsLen = vTabButtons.length;

  vTabButtons.forEach(el => {
    el.addEventListener('click', function () {
      const targetId = this.getAttribute('target-id');
      // Old Tab
      amv2.querySelector('.amv2-content.active').classList.remove('active');
      amv2
        .querySelector('.amv2-v-tabbar-button.selected')
        .classList.remove('selected');
      // New Tab
      document.getElementById(targetId).classList.add('active');
      this.classList.add('selected');

      scrollBarSetter();
    });
  });

  const tabButtons = [...amv2.querySelectorAll('.amv2-tabbar-button')];

  tabButtons.forEach(el => {
    el.addEventListener('click', async function () {
      /* Exit Animation */
      amv2ContentContainer.style.opacity = 0;
      amv2ContentContainer.style.transform = 'translateY(-24px)';

      await waitUntil(300);
      /* END - Exit Animation */

      const { category } = this.dataset;

      // Old Category
      amv2
        .querySelector('.amv2-tabbar-button.selected')
        .classList.remove('selected');
      // Old Board
      amv2
        .querySelector('.amv2-v-tabbar-button.selected')
        .classList.remove('selected');

      // New Category
      this.classList.add('selected');

      vTabButtons.forEach(item => {
        if (item.dataset.categories?.indexOf(category) !== -1) {
          item.style.display = 'block';
        } else {
          item.style.display = 'none';
        }
      });

      for (let i = 0; i < vTabButtonsLen; i++) {
        const item = vTabButtons[i];
        const { style, classList } = item;
        if (style.display == 'block') {
          classList.add('selected');
          item.click();
          break;
        }
      }

      const cards = amv2.querySelectorAll(sectionItem);
      cards.forEach(card => card.remove());

      // Hide Sections
      const foundationSections = amv2.querySelectorAll(
        '.amv2-section--foundation'
      );
      foundationSections.forEach(card => (card.style.display = 'none'));

      const advancedSections = amv2.querySelectorAll('.amv2-section--advanced');
      advancedSections.forEach(card => (card.style.display = 'none'));
      // END - Hide Sections

      allModules.forEach(moduleItem => {
        const { id, modules } = moduleItem;

        modules.forEach(mod => {
          const { categories, level } = mod.dataset;

          if (categories.indexOf(category) !== -1) {
            amv2
              .querySelector(`#${id} .amv2-section__list--${level}`)
              .append(mod);

            amv2.querySelector(`#${id} .amv2-section--${level}`).style.display =
              'block';
          }
        });
      });

      if (category == 'scrum') {
        document
          .querySelector('[target-id="safe"]')
          .classList.remove('selected');

        document.querySelector('[target-id="scrum"]').classList.add('selected');
      }

      amv2ContentContainer.style.opacity = 1;
      amv2ContentContainer.style.transform = 'translateY(0)';

      scrollBarSetter();
    });
  });

  scrollBarSetter();
})();
